import type { OnboardingModuleConfigRequest } from 'bundles/onboarding-common/hooks/useGetOnboardingModuleConfig';
import type { InferredRole } from 'bundles/onboarding-common/types';

type GenericModuleConfig = {
  __typename: 'GenericModule';
  questionPath: string[];
};

type InferredRoleModuleConfig = {
  __typename: 'InferredRoleModule';
  inferredRole: InferredRole;
};

type OnboardingModuleConfigResponse = {
  displayModule: boolean;
  module: GenericModuleConfig | InferredRoleModuleConfig | null;
};

const getMockInferredRoleModuleConfig = (inferredRole: InferredRole): InferredRoleModuleConfig => ({
  __typename: 'InferredRoleModule',
  inferredRole,
});

const mockGenericModuleConfig = (questionPath: string[]): GenericModuleConfig => ({
  __typename: 'GenericModule',
  questionPath,
});

const getMockInferredRoleModuleResponse = (inferredRole: InferredRole) => ({
  displayModule: true,
  module: getMockInferredRoleModuleConfig(inferredRole),
});

const getMockedResponseForOnboardingModuleConfig = ({
  entrypoint,
  inferredRole,
}: OnboardingModuleConfigRequest): OnboardingModuleConfigResponse => {
  switch (entrypoint) {
    case 'LIHP_HOME':
      return inferredRole
        ? getMockInferredRoleModuleResponse(inferredRole)
        : {
            displayModule: true,
            module: mockGenericModuleConfig(['LEARNING_GOAL', 'ROLE', 'SKILL']),
          };
    case 'SEARCH':
      return inferredRole
        ? getMockInferredRoleModuleResponse(inferredRole)
        : {
            displayModule: true,
            module: mockGenericModuleConfig(['LEARNING_GOAL', 'SKILL']),
          };
    case 'RDP':
      return getMockInferredRoleModuleResponse(
        inferredRole || {
          id: 'data-analyst',
          name: 'Data Analyst',
        }
      );
    default:
      return {
        displayModule: false,
        module: null,
      };
  }
};

export { getMockedResponseForOnboardingModuleConfig };
